(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('editorial-benefits-carousel')) {
    class EditorialBenefitsCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return

        this.track = this.querySelector('[data-eb-track]')
        this.originalItems = Array.from(this.querySelectorAll('[data-eb-item]'))
        this.slides = this.originalItems
        this.previousButton = this.querySelector('[data-eb-prev]')
        this.nextButton = this.querySelector('[data-eb-next]')

        if (!this.track || this.originalItems.length === 0) return

        this.initialized = true
        this.sliderEnabled = this.dataset.sliderEnabled === 'true'
        this.tabletColumns = Math.max(2, Math.min(3, Number(this.dataset.tabletColumns) || 2))
        this.showNavigation = this.dataset.showNavigation === 'true'
        this.loop = this.dataset.loop === 'true'
        this.autoplay = this.dataset.autoplay === 'true'
        this.autoplayDelay = Math.max(2000, Number(this.dataset.autoplayDelay) || 5000)
        this.pauseOnHover = this.dataset.pauseOnHover === 'true'
        this.mediaQuery = window.matchMedia('(max-width: 1023px)')
        this.mobileQuery = window.matchMedia('(max-width: 767px)')
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.pauseReasons = new Set()
        this.inView = true
        this.pointerDown = false
        this.isJumping = false
        this.loopBuilt = false
        this.cloneCount = 0
        this.loopSignature = ''
        this.logicalIndex = 0
        this.cloneSerial = 0
        this.scrollFrame = 0
        this.viewportFrame = 0
        this.jumpFrame = 0
        this.settleTimer = 0
        this.autoplayTimer = 0
        this.controller = new AbortController()
        const signal = this.controller.signal

        this.handleScroll = () => {
          if (!this.isJumping && !this.scrollFrame) {
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = 0
              this.update()
            })
          }

          if (!this.isJumping) this.queueSettle()
        }

        this.handleSettle = () => {
          if (this.settleTimer) {
            window.clearTimeout(this.settleTimer)
            this.settleTimer = 0
          }

          if (this.pointerDown || this.isJumping) return

          if (this.loopBuilt) this.normalizeLoop()
          this.update()
          this.scheduleAutoplay()
        }

        this.handleViewportChange = () => {
          if (this.viewportFrame) return

          this.viewportFrame = requestAnimationFrame(() => {
            this.viewportFrame = 0
            this.syncLoop()
            if (!this.isActive() && this.getScrollPosition() > 0) this.jumpToPosition(0)
            this.update()
            this.scheduleAutoplay()
          })
        }

        this.handleVisibilityChange = () => {
          if (document.hidden) {
            this.pause('hidden')
          } else {
            this.resume('hidden')
          }
        }

        this.handleBlockSelect = (event) => {
          if (!this.contains(event.target)) return
          this.pause('editor')
          const item = event.target.closest('[data-eb-item]')
          if (item && this.isActive()) {
            const originalIndex = this.originalItems.indexOf(item)
            const slideIndex = this.loopBuilt ? this.cloneCount + originalIndex : originalIndex
            this.scrollToSlide(slideIndex, 'auto')
            this.queueSettle(60)
          }
        }

        this.handleBlockDeselect = (event) => {
          if (!this.contains(event.target)) return
          this.resume('editor')
        }

        this.track.addEventListener('scroll', this.handleScroll, { passive: true, signal })
        this.track.addEventListener('scrollend', this.handleSettle, { passive: true, signal })
        this.track.addEventListener(
          'pointerdown',
          () => {
            this.pointerDown = true
            this.pause('pointer')
          },
          { passive: true, signal }
        )
        window.addEventListener(
          'pointerup',
          () => {
            this.pointerDown = false
            this.resume('pointer')
            this.queueSettle(80)
          },
          { passive: true, signal }
        )
        window.addEventListener(
          'pointercancel',
          () => {
            this.pointerDown = false
            this.resume('pointer')
            this.queueSettle(80)
          },
          { passive: true, signal }
        )
        this.track.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== this.track) return

            if (event.key === 'ArrowLeft') {
              event.preventDefault()
              this.move(this.isRtl() ? 1 : -1, true)
            } else if (event.key === 'ArrowRight') {
              event.preventDefault()
              this.move(this.isRtl() ? -1 : 1, true)
            } else if (event.key === 'Home') {
              event.preventDefault()
              this.clearAutoplay()
              this.scrollToSlide(this.loopBuilt ? this.cloneCount : 0)
              this.queueSettle()
            } else if (event.key === 'End') {
              event.preventDefault()
              this.clearAutoplay()
              this.scrollToSlide(
                this.loopBuilt ? this.cloneCount + this.originalItems.length - 1 : this.originalItems.length - 1
              )
              this.queueSettle()
            }
          },
          { signal }
        )

        this.previousButton?.addEventListener('click', () => this.move(-1, true), { signal })
        this.nextButton?.addEventListener('click', () => this.move(1, true), { signal })

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.pause('hover'), { signal })
          this.addEventListener('mouseleave', () => this.resume('hover'), { signal })
        }

        this.addEventListener('focusin', () => this.pause('focus'), { signal })
        this.addEventListener(
          'focusout',
          (event) => {
            if (!this.contains(event.relatedTarget)) this.resume('focus')
          },
          { signal }
        )

        document.addEventListener('visibilitychange', this.handleVisibilityChange, { signal })
        document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal })
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { signal })
        this.mediaQuery.addEventListener('change', this.handleViewportChange)
        this.mobileQuery.addEventListener('change', this.handleViewportChange)
        this.motionQuery.addEventListener('change', this.handleViewportChange)

        this.resizeObserver = new ResizeObserver(this.handleViewportChange)
        this.resizeObserver.observe(this.track)

        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.inView = entries[0]?.isIntersecting ?? true
              if (this.inView) {
                this.resume('viewport')
              } else {
                this.pause('viewport')
              }
            },
            { threshold: 0.15 }
          )
          this.intersectionObserver.observe(this)
        }

        requestAnimationFrame(() => {
          this.syncLoop()
          this.update()
          this.scheduleAutoplay()
        })
      }

      disconnectedCallback() {
        if (!this.initialized) return
        this.clearAutoplay()
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame)
        if (this.viewportFrame) cancelAnimationFrame(this.viewportFrame)
        if (this.jumpFrame) cancelAnimationFrame(this.jumpFrame)
        if (this.settleTimer) window.clearTimeout(this.settleTimer)
        this.controller?.abort()
        this.resizeObserver?.disconnect()
        this.intersectionObserver?.disconnect()
        this.mediaQuery?.removeEventListener('change', this.handleViewportChange)
        this.mobileQuery?.removeEventListener('change', this.handleViewportChange)
        this.motionQuery?.removeEventListener('change', this.handleViewportChange)
        this.destroyLoop(false)
        this.track.classList.remove('is-jumping')
        this.isJumping = false
        this.initialized = false
      }

      isActive() {
        return this.sliderEnabled && this.mediaQuery.matches
      }

      getVisibleCount() {
        return this.mobileQuery.matches ? 1 : this.tabletColumns
      }

      getMaxScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth)
      }

      isRtl() {
        return getComputedStyle(this.track).direction === 'rtl'
      }

      getScrollPosition() {
        return this.isRtl() ? Math.abs(this.track.scrollLeft) : this.track.scrollLeft
      }

      getSlidePosition(slide) {
        if (!slide || this.slides.length === 0) return 0
        return Math.abs(slide.offsetLeft - this.slides[0].offsetLeft)
      }

      isAtStart() {
        return this.getScrollPosition() <= 2
      }

      isAtEnd() {
        return this.getScrollPosition() >= this.getMaxScroll() - 2
      }

      getCurrentSlideIndex() {
        const position = this.getScrollPosition()
        let closestIndex = 0
        let closestDistance = Number.POSITIVE_INFINITY

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(this.getSlidePosition(slide) - position)
          if (distance < closestDistance) {
            closestDistance = distance
            closestIndex = index
          }
        })

        return closestIndex
      }

      scrollToPosition(position, behavior) {
        const target = Math.max(0, Math.min(position, this.getMaxScroll()))
        this.track.scrollTo({
          left: this.isRtl() ? target * -1 : target,
          behavior: behavior || (this.motionQuery.matches ? 'auto' : 'smooth')
        })
      }

      scrollToSlide(index, behavior) {
        const targetIndex = Math.max(0, Math.min(index, this.slides.length - 1))
        this.scrollToPosition(this.getSlidePosition(this.slides[targetIndex]), behavior)
      }

      jumpToPosition(position) {
        const target = Math.max(0, Math.min(position, this.getMaxScroll()))

        if (this.jumpFrame) cancelAnimationFrame(this.jumpFrame)
        this.isJumping = true
        this.track.classList.add('is-jumping')
        this.track.scrollLeft = this.isRtl() ? target * -1 : target
        this.jumpFrame = requestAnimationFrame(() => {
          this.track.classList.remove('is-jumping')
          this.isJumping = false
          this.jumpFrame = 0
        })
      }

      jumpToSlide(index) {
        const targetIndex = Math.max(0, Math.min(index, this.slides.length - 1))
        this.jumpToPosition(this.getSlidePosition(this.slides[targetIndex]))
      }

      createClone(item, position, originalIndex) {
        const clone = item.cloneNode(true)
        const cloneKey = `${this.cloneSerial}-${position}-${originalIndex}`
        this.cloneSerial += 1

        clone.removeAttribute('data-eb-item')
        clone.removeAttribute('data-slide-label')
        clone.removeAttribute('role')
        clone.removeAttribute('aria-label')
        clone.setAttribute('data-eb-clone', '')
        clone.setAttribute('data-eb-clone-index', String(originalIndex))
        clone.setAttribute('aria-hidden', 'true')

        const nodes = [clone, ...clone.querySelectorAll('*')]
        nodes.forEach((node) => {
          Array.from(node.attributes).forEach((attribute) => {
            if (attribute.name.startsWith('data-shopify-')) node.removeAttribute(attribute.name)
          })
        })

        const idMap = new Map()
        nodes.forEach((node) => {
          if (!node.id) return
          const originalId = node.id
          const safeId = originalId.replace(/[^a-zA-Z0-9_-]/g, '-')
          const cloneId = `${safeId}-eb-clone-${cloneKey}`
          idMap.set(originalId, cloneId)
          node.id = cloneId
        })

        const referenceAttributes = [
          'href',
          'xlink:href',
          'fill',
          'stroke',
          'filter',
          'clip-path',
          'mask',
          'marker-start',
          'marker-mid',
          'marker-end',
          'aria-labelledby',
          'aria-describedby',
          'for'
        ]

        nodes.forEach((node) => {
          referenceAttributes.forEach((attributeName) => {
            const value = node.getAttribute(attributeName)
            if (!value) return

            let nextValue = value
            if (attributeName === 'aria-labelledby' || attributeName === 'aria-describedby') {
              nextValue = value
                .split(/\s+/)
                .map((id) => idMap.get(id) || id)
                .join(' ')
            } else if (attributeName === 'for' && idMap.has(value)) {
              nextValue = idMap.get(value)
            } else {
              idMap.forEach((newId, oldId) => {
                nextValue = nextValue.split(`#${oldId}`).join(`#${newId}`)
              })
            }

            if (nextValue !== value) node.setAttribute(attributeName, nextValue)
          })
        })

        clone
          .querySelectorAll('a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]')
          .forEach((element) => element.setAttribute('tabindex', '-1'))

        return clone
      }

      buildLoop(logicalIndex) {
        const itemCount = this.originalItems.length
        this.cloneCount = Math.min(this.getVisibleCount(), itemCount)
        const leadingFragment = document.createDocumentFragment()
        const trailingFragment = document.createDocumentFragment()

        this.originalItems.slice(itemCount - this.cloneCount).forEach((item, index) => {
          leadingFragment.append(
            this.createClone(item, 'leading', itemCount - this.cloneCount + index)
          )
        })

        this.originalItems.slice(0, this.cloneCount).forEach((item, index) => {
          trailingFragment.append(this.createClone(item, 'trailing', index))
        })

        this.track.insertBefore(leadingFragment, this.track.firstChild)
        this.track.append(trailingFragment)
        this.slides = Array.from(this.track.children).filter((item) => item.classList.contains('eb__item'))
        this.loopBuilt = true
        this.loopSignature = `${this.cloneCount}:${itemCount}`
        this.logicalIndex = ((logicalIndex % itemCount) + itemCount) % itemCount
        this.jumpToSlide(this.cloneCount + this.logicalIndex)
      }

      destroyLoop(resetPosition = true) {
        this.track.querySelectorAll('[data-eb-clone]').forEach((clone) => clone.remove())
        this.slides = this.originalItems
        this.loopBuilt = false
        this.cloneCount = 0
        this.loopSignature = ''
        if (resetPosition) this.jumpToPosition(0)
      }

      syncLoop() {
        const itemCount = this.originalItems.length
        const visibleCount = this.getVisibleCount()
        const shouldLoop = this.isActive() && this.loop && itemCount > visibleCount
        const signature = `${Math.min(visibleCount, itemCount)}:${itemCount}`

        if (shouldLoop && this.loopBuilt && this.loopSignature === signature) return

        const logicalIndex = this.logicalIndex
        this.destroyLoop(false)

        if (shouldLoop) {
          this.buildLoop(logicalIndex)
        } else {
          this.jumpToPosition(0)
        }
      }

      normalizeLoop() {
        if (!this.loopBuilt) return this.getCurrentSlideIndex()

        const itemCount = this.originalItems.length
        const realStart = this.cloneCount
        const realEnd = realStart + itemCount
        let currentIndex = this.getCurrentSlideIndex()
        let targetIndex = currentIndex

        if (currentIndex < realStart) {
          targetIndex = currentIndex + itemCount
        } else if (currentIndex >= realEnd) {
          targetIndex = currentIndex - itemCount
        }

        this.logicalIndex = ((targetIndex - realStart) % itemCount + itemCount) % itemCount
        if (targetIndex !== currentIndex) this.jumpToSlide(targetIndex)

        return targetIndex
      }

      move(direction, userInitiated) {
        if (!this.overflowing) return

        this.clearAutoplay()

        if (this.loopBuilt) {
          const currentIndex = this.normalizeLoop()
          const targetIndex = Math.max(0, Math.min(currentIndex + direction, this.slides.length - 1))
          this.scrollToSlide(targetIndex)
          this.queueSettle()
          return
        }

        const currentIndex = this.getCurrentSlideIndex()
        const targetIndex = Math.max(0, Math.min(currentIndex + direction, this.slides.length - 1))
        this.scrollToSlide(targetIndex)
        this.queueSettle()
      }

      queueSettle(delay = 160) {
        if (this.settleTimer) window.clearTimeout(this.settleTimer)
        this.settleTimer = window.setTimeout(this.handleSettle, delay)
      }

      update() {
        const active = this.isActive()
        this.overflowing = active && this.originalItems.length > this.getVisibleCount()
        const showControls = this.overflowing && this.showNavigation

        this.classList.toggle('is-overflowing', this.overflowing)
        this.classList.toggle('has-navigation', showControls)
        this.track.tabIndex = this.overflowing ? 0 : -1

        if (this.overflowing) {
          this.setAttribute('role', 'region')
          this.setAttribute('aria-roledescription', 'carousel')
          this.setAttribute('aria-label', this.dataset.accessibilityLabel || 'Benefits')
          this.track.setAttribute('aria-live', 'off')
          this.originalItems.forEach((item) => {
            item.setAttribute('role', 'group')
            item.setAttribute('aria-label', item.dataset.slideLabel)
          })
        } else {
          this.removeAttribute('role')
          this.removeAttribute('aria-roledescription')
          this.removeAttribute('aria-label')
          this.track.removeAttribute('aria-live')
          this.originalItems.forEach((item) => {
            item.removeAttribute('role')
            item.removeAttribute('aria-label')
          })
        }

        if (this.previousButton) {
          this.previousButton.hidden = !showControls
          this.previousButton.disabled = showControls && !this.loopBuilt && this.isAtStart()
          this.previousButton.setAttribute('aria-disabled', String(this.previousButton.disabled))
        }

        if (this.nextButton) {
          this.nextButton.hidden = !showControls
          this.nextButton.disabled = showControls && !this.loopBuilt && this.isAtEnd()
          this.nextButton.setAttribute('aria-disabled', String(this.nextButton.disabled))
        }

        if (!this.overflowing) this.clearAutoplay()
      }

      pause(reason) {
        this.pauseReasons.add(reason)
        this.clearAutoplay()
      }

      resume(reason) {
        this.pauseReasons.delete(reason)
        this.scheduleAutoplay()
      }

      clearAutoplay() {
        if (!this.autoplayTimer) return
        window.clearTimeout(this.autoplayTimer)
        this.autoplayTimer = 0
      }

      scheduleAutoplay() {
        this.clearAutoplay()

        if (
          !this.autoplay ||
          !this.overflowing ||
          this.motionQuery.matches ||
          this.pauseReasons.size > 0 ||
          document.hidden ||
          !this.inView
        ) {
          return
        }

        if (!this.loopBuilt && this.isAtEnd()) return

        this.autoplayTimer = window.setTimeout(() => {
          this.autoplayTimer = 0
          this.move(1, false)
        }, this.autoplayDelay)
      }
    }

    customElements.define('editorial-benefits-carousel', EditorialBenefitsCarousel)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-trending"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-trending-carousel')) {
    class ProductTrendingCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return

        this.slides = Array.from(this.querySelectorAll('[data-pt-slide]'))
        this.stage = this.querySelector('[data-pt-stage]')
        this.previousButton = this.querySelector('[data-pt-previous]')
        this.nextButton = this.querySelector('[data-pt-next]')
        this.dots = Array.from(this.querySelectorAll('[data-pt-dot]'))
        this.status = this.querySelector('[data-pt-status]')
        this.autoplay = this.dataset.autoplay === 'true'
        this.autoplayDelay = Math.max(2000, Number(this.dataset.autoplayDelay) || 5000)
        this.pauseOnHover = this.dataset.pauseOnHover === 'true'
        this.showComparePrice = this.dataset.showComparePrice === 'true'
        this.moneyFormat = this.dataset.moneyFormat || ''
        this.currency = this.dataset.currency || 'USD'
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.pauseReasons = new Set()
        this.activeIndex = Math.max(0, this.slides.findIndex((slide) => !slide.hidden))
        this.inView = true
        this.autoplayTimer = 0
        this.touchStartX = null
        this.controller = new AbortController()
        this.initialized = true
        const signal = this.controller.signal

        this.initializeCards()

        if (this.slides.length < 2) return

        this.previousButton?.addEventListener(
          'click',
          () => {
            this.showSlide(this.activeIndex - 1, true)
          },
          { signal }
        )

        this.nextButton?.addEventListener(
          'click',
          () => {
            this.showSlide(this.activeIndex + 1, true)
          },
          { signal }
        )

        this.dots.forEach((dot) => {
          dot.addEventListener(
            'click',
            () => {
              this.showSlide(Number(dot.dataset.slideIndex), true)
            },
            { signal }
          )
        })

        this.addEventListener(
          'keydown',
          (event) => {
            if (event.target !== this) return

            if (event.key === 'ArrowLeft') {
              event.preventDefault()
              this.showSlide(this.activeIndex + (this.isRtl() ? 1 : -1), true)
            } else if (event.key === 'ArrowRight') {
              event.preventDefault()
              this.showSlide(this.activeIndex + (this.isRtl() ? -1 : 1), true)
            } else if (event.key === 'Home') {
              event.preventDefault()
              this.showSlide(0, true)
            } else if (event.key === 'End') {
              event.preventDefault()
              this.showSlide(this.slides.length - 1, true)
            }
          },
          { signal }
        )

        this.stage?.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1 || event.target.closest('button, a, input, label')) return
            this.touchStartX = event.touches[0].clientX
          },
          { passive: true, signal }
        )

        this.stage?.addEventListener(
          'touchend',
          (event) => {
            if (this.touchStartX === null || event.changedTouches.length !== 1) return
            const distance = event.changedTouches[0].clientX - this.touchStartX
            this.touchStartX = null
            if (Math.abs(distance) < 45) return
            const direction = distance < 0 ? 1 : -1
            this.showSlide(this.activeIndex + (this.isRtl() ? direction * -1 : direction), true)
          },
          { passive: true, signal }
        )

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => this.pause('hover'), { signal })
          this.addEventListener('mouseleave', () => this.resume('hover'), { signal })
        }

        this.addEventListener('focusin', () => this.pause('focus'), { signal })
        this.addEventListener(
          'focusout',
          (event) => {
            if (!this.contains(event.relatedTarget)) this.resume('focus')
          },
          { signal }
        )

        this.handleVisibility = () => {
          if (document.hidden) {
            this.pause('hidden')
          } else {
            this.resume('hidden')
          }
        }

        this.handleBlockSelect = (event) => {
          const slide = event.target.closest?.('[data-pt-slide]')
          if (!slide || !this.contains(slide)) return
          const index = this.slides.indexOf(slide)
          if (index >= 0) this.showSlide(index, false)
          this.pause('editor')
        }

        this.handleBlockDeselect = (event) => {
          if (this.contains(event.target)) this.resume('editor')
        }

        document.addEventListener('visibilitychange', this.handleVisibility, { signal })
        document.addEventListener('shopify:block:select', this.handleBlockSelect, { signal })
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect, { signal })
        this.motionQuery.addEventListener('change', this.handleVisibility)

        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(
            (entries) => {
              this.inView = entries[0]?.isIntersecting ?? true
              if (this.inView) {
                this.resume('viewport')
              } else {
                this.pause('viewport')
              }
            },
            { threshold: 0.2 }
          )
          this.intersectionObserver.observe(this)
        }

        this.scheduleAutoplay()
      }

      disconnectedCallback() {
        if (!this.initialized) return
        this.clearAutoplay()
        this.controller?.abort()
        this.intersectionObserver?.disconnect()
        this.motionQuery?.removeEventListener('change', this.handleVisibility)
        this.initialized = false
      }

      initializeCards() {
        this.querySelectorAll('[data-pt-card]').forEach((card) => {
          const variantsNode = card.querySelector('[data-pt-variants]')
          if (!variantsNode) return

          try {
            card.ptVariants = JSON.parse(variantsNode.textContent)
          } catch {
            card.ptVariants = []
          }

          card.querySelectorAll('[data-pt-option]').forEach((input) => {
            input.addEventListener(
              'change',
              () => {
                this.updateVariant(card)
              },
              { signal: this.controller.signal }
            )
          })

          this.updateVariant(card)
        })

        window.MinimogTheme?.Wishlist?.setWishlistButtonsState?.()
      }

      updateVariant(card) {
        const groups = Array.from(card.querySelectorAll('[data-pt-option-group]')).sort(
          (first, second) => Number(first.dataset.position) - Number(second.dataset.position)
        )
        const variantInput = card.querySelector('[data-pt-variant-input]')
        const selectedOptions = []

        groups.forEach((group, groupIndex) => {
          const inputs = Array.from(group.querySelectorAll('[data-pt-option]'))
          const availableForPrefix = card.ptVariants.some(
            (candidate) =>
              candidate.available &&
              selectedOptions.every((value, index) => candidate.options[index] === value)
          )

          inputs.forEach((input) => {
            input.disabled =
              availableForPrefix &&
              !card.ptVariants.some(
                (candidate) =>
                  candidate.available &&
                  candidate.options[groupIndex] === input.value &&
                  selectedOptions.every((value, index) => candidate.options[index] === value)
              )
          })

          let selected = group.querySelector('[data-pt-option]:checked')
          if (!selected || selected.disabled) {
            selected = inputs.find((input) => !input.disabled)
            if (selected) selected.checked = true
          }

          const selectedLabel = group.querySelector('[data-pt-option-selected]')
          if (selectedLabel) selectedLabel.textContent = selected?.value || ''
          selectedOptions.push(selected?.value)
        })

        const hasAllOptions = selectedOptions.every((value) => typeof value === 'string')
        const variant =
          groups.length === 0
            ? card.ptVariants.find(
                (candidate) => String(candidate.id) === String(card.dataset.selectedVariantId)
              ) || card.ptVariants[0]
            : hasAllOptions
              ? card.ptVariants.find((candidate) =>
                  candidate.options.every((value, index) => value === selectedOptions[index])
                )
              : null
        const addButton = card.querySelector('[data-pt-add-button]')
        const addButtonText = addButton?.querySelector('[data-atc-text]')

        if (variantInput) {
          variantInput.value = variant?.id || ''
          variantInput.disabled = !variant
        }

        if (addButton) {
          const available = Boolean(variant?.available)
          addButton.disabled = !available
          if (addButtonText) {
            addButtonText.textContent = !variant
              ? addButton.dataset.unavailableLabel
              : available
                ? addButton.dataset.addLabel
                : addButton.dataset.soldLabel
          }
        }

        if (!variant) return

        const currentPrice = card.querySelector('[data-pt-current-price]')
        const comparePrice = card.querySelector('[data-pt-compare-price]')
        if (currentPrice) currentPrice.textContent = this.formatMoney(variant.price)
        if (comparePrice) {
          const hasComparePrice =
            this.showComparePrice && Number(variant.compare_at_price) > Number(variant.price)
          comparePrice.hidden = !hasComparePrice
          if (hasComparePrice) comparePrice.textContent = this.formatMoney(variant.compare_at_price)
        }

        const image = card.querySelector('[data-pt-image][data-dynamic="true"]')
        if (image) {
          const nextSource = variant.featured_image?.src || image.dataset.defaultSrc
          if (nextSource && image.src !== nextSource) {
            image.removeAttribute('srcset')
            image.src = nextSource
          }
        }
      }

      formatMoney(cents) {
        if (typeof window.formatMoney === 'function' && this.moneyFormat) {
          return window.formatMoney(cents, this.moneyFormat)
        }

        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: this.currency
          }).format(Number(cents) / 100)
        } catch {
          return String(cents)
        }
      }

      showSlide(nextIndex, announce) {
        const normalizedIndex = (nextIndex + this.slides.length) % this.slides.length
        if (normalizedIndex === this.activeIndex) {
          if (announce) this.restartAutoplay()
          return
        }

        this.slides.forEach((slide, index) => {
          const active = index === normalizedIndex
          slide.hidden = !active
          slide.inert = !active
          slide.setAttribute('aria-hidden', String(!active))
          slide.classList.toggle('is-active', active)
          slide.classList.remove('is-entering')
          if (active) {
            void slide.offsetWidth
            slide.classList.add('is-entering')
          }
        })

        this.dots.forEach((dot, index) => {
          const active = index === normalizedIndex
          dot.classList.toggle('is-active', active)
          dot.setAttribute('aria-current', String(active))
        })

        this.activeIndex = normalizedIndex
        if (announce && this.status) {
          this.status.textContent = this.slides[normalizedIndex].dataset.slideLabel || ''
        }
        this.restartAutoplay()
      }

      isRtl() {
        return getComputedStyle(this).direction === 'rtl'
      }

      pause(reason) {
        this.pauseReasons.add(reason)
        this.clearAutoplay()
      }

      resume(reason) {
        this.pauseReasons.delete(reason)
        this.scheduleAutoplay()
      }

      clearAutoplay() {
        if (!this.autoplayTimer) return
        window.clearTimeout(this.autoplayTimer)
        this.autoplayTimer = 0
      }

      restartAutoplay() {
        this.clearAutoplay()
        this.scheduleAutoplay()
      }

      scheduleAutoplay() {
        this.clearAutoplay()
        if (
          !this.autoplay ||
          this.slides.length < 2 ||
          this.motionQuery.matches ||
          this.pauseReasons.size > 0 ||
          document.hidden ||
          !this.inView
        ) {
          return
        }

        this.autoplayTimer = window.setTimeout(() => {
          this.autoplayTimer = 0
          this.showSlide(this.activeIndex + 1, false)
        }, this.autoplayDelay)
      }
    }

    customElements.define('product-trending-carousel', ProductTrendingCarousel)
  }

  } catch(e) { console.error(e); }
})();
})();
